// index
import LogoTopLeft from "../images/LogoTopLeft.png";
import TopIcon from "../images/TopIcon.png";
import FacebookIcon from "../images/facebook_icon.png";
import InstagramIcon from "../images/instagram_icon.png";
import TwitterIcon from "../images/twitter_idcon.png";
import ShoppingCartIcon from "../images/ShoppingCartIcon.png";
import contents_somemono from "../images/contents_somemono.png";
import ContentsButton from "../images/contents_button.png";
import contents_standh from "../images/contents_standh.png";
import ContentsDiamond from "../images/contents-diamond.png";
import ContentsMiddleShip from "../images/ContentsMiddleShip.png";
import top_middle_name from "../images/top_middle_name.png";
import Newsimg_01 from "../images/news_01.png";
import Newsimg_02 from "../images/news_02.png";
import Newsimg_03 from "../images/news_03.png";
import ContentsBackgroundImg from "../images/ContentsBackgroundImg.png";
import footer_backgrond from "../images/footer_backgrond.png";
// Article

import PrivacyTop from "../images/ArticleTop.png";
import Spirit_contentTop from "../images/Spirit_contentTop.png"
import Spirit_cirtificate from "../images/Spirit_cirtificate.png"
import Articleimg_01 from "../images/Articleimg_01.png"
import Articleimg_02 from "../images/Articleimg_02.png"
import Articleimg_03 from "../images/Articleimg_03.png"
import Articleimg_04 from "../images/Articleimg_04.png"
import Articleimg_06 from "../images/Articleimg_06.png"
import Articleimg_08 from "../images/Articleimg_08.png"


function imgPreload(){

    let imagesUrl = [
        // top
        {LogoTopLeft},
        {TopIcon},
        {FacebookIcon},
        {InstagramIcon},
        {TwitterIcon},
        {ShoppingCartIcon},
        {contents_somemono},
        {ContentsButton},
        {contents_standh},
        {ContentsDiamond},
        {ContentsMiddleShip},
        {top_middle_name},
        {Newsimg_01},
        {Newsimg_02},
        {Newsimg_03},
        {ContentsBackgroundImg},
        {footer_backgrond},
        // article
        {PrivacyTop},
        {Spirit_contentTop},
        {Spirit_cirtificate},
        {Articleimg_01},
        {Articleimg_02},
        {Articleimg_03},
        {Articleimg_04},
        {Articleimg_06},
        {Articleimg_08}
    ]

    let images = new Array(imagesUrl.length);
    for (let i = 0; i < imagesUrl.length; i++) {
        images[i] = new Image()
        images[i].src = imagesUrl[i]
    }
    console.log(images);
}

export default imgPreload;
